import { defineComponent } from 'vue'
import {
  getAvatarColor,
  getAvatarTextColor,
  getAvatarHexColor,
  getAvatarRounded,
} from '../dataObjects/Avatar'
import { isDarkTheme } from '~/cynqueModules/nuxtAccessors'

export default defineComponent({
  methods: {
    getAvatarColor(type: string) {
      return getAvatarColor(type, isDarkTheme())
    },
    getAvatarHexColor(type: string) {
      return getAvatarHexColor(type, isDarkTheme())
    },
    getAvatarTextColor(type: string) {
      return getAvatarTextColor(type, isDarkTheme())
    },
    getAvatarRounded(type: string) {
      return getAvatarRounded(type)
    },
  },
})
